import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {COPY_STRINGS} from '../../constants/translatedCopy';
import doNotUseAccessibleStaticElementInteractions from "A11y/doNotUseAccessibleStaticElementInteractions.js";
import { selectStudentPreChecks, resetStudentPreChecks } from '../StudentPreChecks/studentPreChecksSlice';
import { resetReaderManagerState } from '../Reader/ReaderManagerEvents/ReaderManagerSlice';
import { listenerMiddleware } from '../../store';
import { resetStudentPreChecksMiddlewareListeners } from '../StudentPreChecks/studentPreChecksMiddlewareListener';
import TutorPickerIcon from '../../images/icons/TutorPickerIcon.svg';
import EnabledMicIcon from '../../images/icons/enabledMic.svg';
import './StudentHomeSettingsModal.scss';

const StudentHomeSettingsModal = (props) => {
  const [buttonsDisabled, setButtonsDisabled] = useState(true);
  const [showMicConfirmation, setShowMicConfirmation] = useState(false);
  const dispatch = useDispatch();
  const studentPreChecks = useSelector(selectStudentPreChecks);

  useEffect(() => {
    // Enable buttons after a short delay
    const timer = setTimeout(() => {
      setButtonsDisabled(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleTutorClick = () => {
    if (!buttonsDisabled) {
      props.speech.abortSpeech(() => {
        props.onClose();
        props.closeStudentHomeModal();
        setTimeout(() => {
          props.history.push("/student/tutorPicker");
        }, 100);
      });
    }
  }

  const handleMicTestClick = () => {
    if (!buttonsDisabled) {
      setShowMicConfirmation(true);
    }
  }

  const handleMicConfirmationCancel = () => {
    setShowMicConfirmation(false);
  }

  const handleMicConfirmationBegin = () => {
    props.speech.abortSpeech(() => {
      // Reset the student pre-checks slice completely
      dispatch(resetStudentPreChecks());
      // Reset the reader manager state to clear any story/transcript state
      dispatch(resetReaderManagerState());
      
      // Clear any existing matchRequest to ensure clean transcript processing
      if (props.speech && props.speech.cancelMatchRequest) {
        props.speech.cancelMatchRequest();
      }
      
      // Re-register the middleware listeners
      resetStudentPreChecksMiddlewareListeners(listenerMiddleware);
      
      // Use the new navigateToMicTest method instead of URL parameters
      props.navigateToMicTest();
    });
  }

  const handleBackClick = () => {
    if (!buttonsDisabled) {
      props.onClose();
    }
  }

  if (showMicConfirmation) {
    return (
      <div className="studentHomeSettingsOverlay">
        <div className="micConfirmationContainer">
          <button 
            className="micConfirmationCloseButton"
            onClick={handleMicConfirmationCancel}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M3.44755 3.4478C4.48895 2.4064 6.17739 2.4064 7.21879 3.4478L15.9998 12.2288L24.7809 3.4478C25.8223 2.4064 27.5107 2.4064 28.5521 3.4478C29.5935 4.48919 29.5935 6.17763 28.5521 7.21903L19.7711 16.0001L28.5521 24.7811C29.5935 25.8225 29.5935 27.511 28.5521 28.5524C27.5107 29.5938 25.8223 29.5938 24.7809 28.5524L15.9998 19.7713L7.21879 28.5524C6.17739 29.5938 4.48895 29.5938 3.44755 28.5524C2.40615 27.511 2.40615 25.8225 3.44755 24.7811L12.2286 16.0001L3.44755 7.21903C2.40615 6.17763 2.40615 4.48919 3.44755 3.4478Z" fill="black"/>
            </svg>
          </button>
          <div className="micConfirmationIcon">
            <img src={EnabledMicIcon} alt="Microphone" />
          </div>
          
          <div className="micConfirmationContent">
            <h2 className="micConfirmationTitle">Test Microphone</h2>
            <p className="micConfirmationDescription">
              Amira will check the microphone's volume and speech recognition to ensure she can hear and understand your student clearly.
            </p>
          </div>
          
          <div className="micConfirmationButtons">
            <button 
              className="micConfirmationButton cancelButton" 
              onClick={handleMicConfirmationCancel}
            >
              Cancel
            </button>
            <button 
              className="micConfirmationButton beginButton" 
              onClick={handleMicConfirmationBegin}
            >
              Begin Test
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="studentHomeSettingsOverlay">
      <div className="studentHomeSettingsContainer">
        <div className="studentHomeSettingsHeader">
          <h2 className="studentHomeSettingsTitle">Settings</h2>
        </div>
        
        <div className="studentHomeSettingsButtons">
          <button 
            className="studentHomeSettingsButton selectTutorButton" 
            onClick={handleTutorClick}
            disabled={buttonsDisabled}
          >
            <img src={TutorPickerIcon} alt="Tutor" className="buttonIcon" />
            <span>Select Tutor</span>
          </button>
          
          <button 
            className="studentHomeSettingsButton testMicButton" 
            onClick={handleMicTestClick}
            disabled={buttonsDisabled}
          >
            <img src={EnabledMicIcon} alt="Microphone" className="buttonIcon" />
            <span>Test Microphone</span>
          </button>
          
          <button 
            className="studentHomeSettingsButton backButton" 
            onClick={handleBackClick}
            disabled={buttonsDisabled}
            style={{ marginTop: '30px' }}
          >
            <span>Back</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export default StudentHomeSettingsModal; 